<template>
  <v-list-item @click="open">
    <v-list-item-avatar>
      <v-icon small color="secondary">fal fa-plus</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="secondary--text">学歴を追加する</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action class="text-xs-right">
      <v-btn text :disabled="true"></v-btn>
    </v-list-item-action>
    <v-dialog scrollable v-model="config.status.active" max-width="600">
      <v-card>
        <v-card-title class="primary amber blue-grey--text text--darken-4">
          <span class="headline">学歴の追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-row dense>
                <v-col cols="12" class="px-3">
                  <v-combobox
                    v-model="form.rank"
                    label="学位"
                    :rules="rules.rank"
                    :items="getRankItems"
                  />
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-text-field required
                    v-model="form.name"
                    label="学校名"
                    :rules="rules.name"
                  />
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-text-field
                    v-model="form.dept"
                    label="学部・学科名"
                  />
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-radio-group required row
                    v-model="form.status"
                    label="在籍状況"
                    :rules="rules.status">
                    <v-radio v-for="(item, key) in getStatusItems" :key="key"
                      color="blue darken-2"
                      :label="item"
                      :value="key"
                    />
                  </v-radio-group>
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-menu lazy offset-y full-width
                    v-model="config.datepicker.date"
                    transition="scale-transition"
                    min-width="290px"
                    :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-text-field readonly required
                        v-model="printFormatedDate"
                        v-on="on"
                        :rules="rules.date"
                        label="卒業・中退日"
                      />
                    </template>
                    <v-date-picker
                      v-model="form.date"
                      color="amber"
                      locale="ja"
                      :day-format="date => new Date(date).getUTCDate()"
                      @input="config.datepicker.date = false"
                    />
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn text
            color="secondary"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="secondary"
            :disabled="!isValid"
            :loading="isLoading"
            @click="submit">追加する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item>
</template>

<script>
export default {
  name: 'insert-modal',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        },
        datepicker: {
          date: false
        }
      },
      meta: {
        ranks: [
          '中学校',
          '高校',
          '高専',
          '専門学校',
          '短大',
          '大学',
          '大学院',
          '博士'
        ]
      },
      form: {
        name: '',
        rank: '',
        dept: '',
        status: '',
        date: ''
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ],
        rank: [
          v => !!v || '必須項目です'
        ],
        status: [
          v => !!v || '必須項目です'
        ],
        date: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        name: '',
        rank: '',
        dept: '',
        status: '',
        date: ''
      })
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'about/insert/meta', {
            cid: this.$route.params.id,
            mtype: 'about.career',
            form: {
              name: this.form.name,
              rank: this.form.rank,
              dept: this.form.dept,
              status: this.form.status,
              date: this.form.date
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'insert',
                data: {
                  type: 'careers',
                  resolve: res.data.data
                }
              })
            }
            this.$set(this.config.status, 'loading', false)
            this.$set(this.config.status, 'active', false)
          })
        })
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    printFormatedDate () {
      return (
        this.form &&
        this.form.date
      ) ? this.$moment(this.form.date).format('YYYY/MM/DD') : ''
    },
    getRankItems () {
      return this.meta.ranks
    },
    getStatusItems () {
      return this.$mango.about.career.status
    }
  }
}
</script>
